import { render } from "./TransfusionChart.vue?vue&type=template&id=4e3a2f18&scoped=true"
import script from "./TransfusionChart.vue?vue&type=script&lang=js"
export * from "./TransfusionChart.vue?vue&type=script&lang=js"

import "./TransfusionChart.vue?vue&type=style&index=0&id=4e3a2f18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3a2f18"]])

export default __exports__